/*
 * Testimonia — skin for the Apippa (Custom Price Calculator) app on wallpaper PDPs.
 * Apippa prices and charges the exact m²; this only re-dresses its markup with the
 * theme calculator's classes so testimonia-wallpaper-calculator.css styles it.
 * The app's own inputs stay in the form (hidden) and keep pricing; "Total" reads the
 * app's computed price.
 */
(function () {
  'use strict';

  // Must match the Apippa formula:
  // MAX((Ancho Metro + 0.05) * (Alto Metro + 0.05), 1) * shopify_product_price
  var TOLERANCE_METERS_PER_DIMENSION = 0.05;
  var MIN_M2 = 1;
  var MAX_DECIMALS = 2;

  var HINT_TEXT = 'Ingresa la medida exacta de tu muro. Sumamos 5 cm de margen al ancho y al alto.';

  // Written into the cart line for production. Apippa only records what the
  // customer typed (the wall), so the size to print is added alongside it.
  var PRINT_SIZE_PROPERTY = 'Medida a imprimir (con margen)';
  var CHARGED_M2_PROPERTY = 'Metros cuadrados cobrados';

  function toNumber(value) {
    return parseFloat(String(value).replace(',', '.'));
  }

  function formatMoney(amount) {
    return '$' + Math.round(amount).toLocaleString('es-CL');
  }

  function formatNumber(n) {
    return n.toLocaleString('es-CL', { maximumFractionDigits: MAX_DECIMALS });
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  // Digits plus one decimal separator — comma or point, whichever the customer
  // types — and at most MAX_DECIMALS decimals.
  function sanitize(raw) {
    var out = '';
    var hasSeparator = false;
    var decimals = 0;
    for (var i = 0; i < raw.length; i++) {
      var ch = raw.charAt(i);
      if (ch >= '0' && ch <= '9') {
        if (hasSeparator) {
          if (decimals >= MAX_DECIMALS) continue;
          decimals++;
        }
        out += ch;
      } else if ((ch === ',' || ch === '.') && !hasSeparator) {
        hasSeparator = true;
        out += ch;
      }
    }
    return out;
  }

  function sources(calc) {
    return calc.querySelectorAll('.numInput-cpc');
  }

  // No upper limit on purpose — walls of any size can be ordered.
  function inRange(input) {
    var value = toNumber(input.value);
    var min = toNumber(input.getAttribute('min'));
    if (!(value > 0)) return false;
    if (isFinite(min) && value < min) return false;
    return true;
  }

  function readDimensions(calc) {
    var inputs = sources(calc);
    return {
      ancho: toNumber(inputs[0].value),
      alto: toNumber(inputs[1].value),
      valid: inRange(inputs[0]) && inRange(inputs[1]),
    };
  }

  function errorText(calc) {
    var input = sources(calc)[0];
    var min = toNumber(input.getAttribute('min'));
    if (isFinite(min) && min > 0) {
      return 'Ingresa el ancho y el alto de tu muro (mínimo ' + formatNumber(min) + ' metros).';
    }
    return 'Ingresa el ancho y el alto de tu muro.';
  }

  function printSize(d) {
    var ancho = d.ancho + TOLERANCE_METERS_PER_DIMENSION;
    var alto = d.alto + TOLERANCE_METERS_PER_DIMENSION;
    return { ancho: ancho, alto: alto, m2: Math.max(ancho * alto, MIN_M2) };
  }

  // The app builds the cart line from the product form (FormData), so hidden
  // properties placed in it travel with the line; ones inside #calculator don't.
  // Every add-to-cart form of this product section gets them (desktop + sticky bar).
  function setOrderProperty(calc, name, value) {
    var section = calc.closest('.product-section') || document;
    var forms = section.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('input[data-testimonia-property="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + name + ']';
        input.setAttribute('data-testimonia-property', name);
        form.appendChild(input);
      }
      input.value = value;
    });
  }

  // m² reacts on every keystroke. The total waits for the app, which reprices
  // after its own 500 ms debounce — see updateTotal.
  function updateArea(calc) {
    var d = readDimensions(calc);
    var m2El = calc.querySelector('[data-testimonia-m2]');
    var totalEl = calc.querySelector('[data-testimonia-total]');
    if (!d.valid) {
      m2El.textContent = '0 m²';
      totalEl.textContent = '$0';
      setOrderProperty(calc, PRINT_SIZE_PROPERTY, '');
      setOrderProperty(calc, CHARGED_M2_PROPERTY, '');
      return;
    }
    var size = printSize(d);
    m2El.textContent = formatNumber(size.m2) + ' m²';
    setOrderProperty(
      calc,
      PRINT_SIZE_PROPERTY,
      formatNumber(size.ancho) + ' × ' + formatNumber(size.alto) + ' m'
    );
    setOrderProperty(calc, CHARGED_M2_PROPERTY, formatNumber(size.m2) + ' m²');
    calc.querySelector('[data-testimonia-error]').hidden = true;
  }

  // The app writes the final price to data-origmoney first, then animates the
  // visible ticker up to it. Reading the attribute skips the count-up.
  function updateTotal(calc) {
    var totalEl = calc.querySelector('[data-testimonia-total]');
    if (!readDimensions(calc).valid) {
      totalEl.textContent = '$0';
      return;
    }
    var ticker = calc.querySelector('#priceTicker');
    var price = ticker ? parseFloat(ticker.getAttribute('data-origmoney')) : NaN;
    if (isFinite(price)) totalEl.textContent = formatMoney(price);
  }

  function skin(calc) {
    if (calc.hasAttribute('data-testimonia-skinned')) return;
    var elements = calc.querySelectorAll(':scope > .element');
    if (elements.length < 2) return;
    calc.setAttribute('data-testimonia-skinned', '');

    var placement = calc.closest('.cpc-calculator-placement');
    if (placement) placement.classList.add('testimonia-wallpaper-calculator');

    var wall = el('div', 'testimonia-wallpaper-calculator__wall');
    var header = el('div', 'testimonia-wallpaper-calculator__wall-header');
    header.appendChild(el('span', '', 'Muro:'));
    header.appendChild(el('span', 'testimonia-wallpaper-calculator__hint', HINT_TEXT));
    var fields = el('div', 'testimonia-wallpaper-calculator__fields');
    wall.appendChild(header);
    wall.appendChild(fields);
    calc.insertBefore(wall, calc.firstChild);

    Array.prototype.forEach.call(elements, function (element, index) {
      element.classList.add('field');
      var label = element.querySelector('label');
      var source = element.querySelector('.numInput-cpc');
      var labelText = label ? label.textContent.trim() : '';

      // The app's field is type="number", which rejects a typed comma in some
      // browsers. Customers type into a text field instead; the app's field is
      // kept (hidden) and fed a point-decimal value, so it still prices and
      // still sends the measurement to the cart.
      var visible = document.createElement('input');
      visible.type = 'text';
      visible.id = 'testimonia-cpc-dimension-' + index;
      visible.className = 'field__input';
      visible.setAttribute('inputmode', 'decimal');
      visible.setAttribute('autocomplete', 'off');
      visible.placeholder = labelText;
      if (label) {
        label.classList.add('visually-hidden');
        label.htmlFor = visible.id;
      }

      source.value = '';
      source.removeAttribute('value');
      source.tabIndex = -1;
      source.setAttribute('aria-hidden', 'true');
      source.classList.add('testimonia-cpc-source');

      visible.addEventListener('input', function () {
        var clean = sanitize(visible.value);
        if (clean !== visible.value) visible.value = clean;
        var n = toNumber(clean);
        source.value = n > 0 ? clean.replace(',', '.').replace(/\.$/, '') : '';
        // Runs the app's inline onkeyup/onchange="PriceUpdation(this)".
        source.dispatchEvent(new Event('keyup', { bubbles: true }));
        source.dispatchEvent(new Event('change', { bubbles: true }));
        updateArea(calc);
      });

      element.insertBefore(visible, source);
      fields.appendChild(element);
    });

    var summary = el('div', 'testimonia-wallpaper-calculator__summary');
    var m2Row = el('div', 'testimonia-wallpaper-calculator__summary-row');
    m2Row.appendChild(el('span', '', 'Metros cuadrados'));
    var m2Value = el('strong', '', '0 m²');
    m2Value.setAttribute('data-testimonia-m2', '');
    m2Row.appendChild(m2Value);
    var totalRow = el('div', 'testimonia-wallpaper-calculator__summary-row');
    totalRow.appendChild(el('span', '', 'Total'));
    var totalValue = el('strong', '', '$0');
    totalValue.setAttribute('data-testimonia-total', '');
    totalRow.appendChild(totalValue);
    summary.appendChild(m2Row);
    summary.appendChild(totalRow);

    var error = el('p', 'testimonia-wallpaper-calculator__error', errorText(calc));
    error.setAttribute('data-testimonia-error', '');
    error.hidden = true;

    var marker = calc.querySelector('.price-marker');
    var anchor = marker ? marker.nextSibling : null;
    calc.insertBefore(summary, anchor);
    calc.insertBefore(error, anchor);

    if (marker) {
      new MutationObserver(function () {
        updateTotal(calc);
      }).observe(marker, { childList: true, characterData: true, attributes: true, subtree: true });
    }

    updateArea(calc);
  }

  // Empty fields would otherwise add the app's 1 m² minimum to the cart.
  // Capture phase, so this runs before the app's own submit handling.
  function guardAddToCart(event) {
    var calc = document.querySelector('#calculator[data-testimonia-skinned]');
    if (!calc || !event.target.closest) return;
    var trigger =
      event.type === 'submit' ? event.target : event.target.closest('.product-form__submit, [name="add"]');
    if (!trigger) return;
    // Only this product's buy buttons — not quick-add on recommended products.
    var section = calc.closest('.product-section');
    if (section && trigger.closest('.product-section') !== section) return;
    if (readDimensions(calc).valid) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    calc.querySelector('[data-testimonia-error]').hidden = false;
    var first = calc.querySelector('.testimonia-wallpaper-calculator__fields .field__input');
    if (first) first.focus();
  }

  function init() {
    var targets = document.querySelectorAll('.cpc-calculator-target');
    if (!targets.length) return;

    Array.prototype.forEach.call(targets, function (target) {
      var calc = target.querySelector('#calculator');
      if (calc) skin(calc);
      // The app renders (and may re-render) the calculator after page load.
      new MutationObserver(function () {
        var current = target.querySelector('#calculator');
        if (current) skin(current);
      }).observe(target, { childList: true });
    });

    document.addEventListener('click', guardAddToCart, true);
    document.addEventListener('submit', guardAddToCart, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
